"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ScenarioContent;
var _react = _interopRequireDefault(require("react"));
var _segmentContent = _interopRequireDefault(require("./segmentContent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ScenarioContent(_ref) {
  var scenario = _ref.scenario,
    handleEmptyState = _ref.handleEmptyState,
    operationPath = _ref.operationPath,
    httpMethod = _ref.httpMethod;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-span-full pl-8 inline"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-04 font-semibold mb-4 flex break-all"
  }, scenario.name), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-02 font-bold mt-4 mb-1 flex break-all"
  }, "Description"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-body-02 mb-8 break-all",
    dangerouslySetInnerHTML: {
      __html: scenario.description
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-02 font-bold mt-4 mb-2 flex break-all"
  }, "Code sample(s)"), /*#__PURE__*/_react.default.createElement(_segmentContent.default, {
    scenario: scenario,
    handleEmptyState: handleEmptyState,
    operationPath: operationPath,
    httpMethod: httpMethod
  })));
}